<template id="userForm">    
    <div>                
        <div class="row">
            <div class="col-md-10">
                <h3>User Form!</h3>
            </div>
        </div>
        <form>
            <div class="row">
                <div class="col-md-4">
                    <div class="form-group">
                        <label for="user_role_id">role</label>
                        <select class="form-control" v-model="form.role_id" @change="onRoleChanged(form.role_id)">
                            <option></option>
                            <option  v-for="role in roles" v-bind:key="role.id" :value="role.id">{{role.title}}</option>
                        </select>
                        <form-error :isError="validateError.role_id.error" :errorMessage="validateError.role_id.message"></form-error>
                    </div>
                </div>                
                <div class="col-md-8">
                    <label for="user_role_id">permissions</label>
                    <div>
                        <h5><span v-for="permission in permissions" v-bind:key="'permission_'+permission.id" class="badge badge-secondary ml-1">{{permission.title}}</span></h5>
                    </div>
                </div>                
            </div>
            <div class="row">
                <div class="col-md-4">
                    <div class="form-group">
                        <label for="user_name">user name</label>
                        <input type="text" class="form-control" v-model="form.name">
                        <form-error :isError="validateError.name.error" :errorMessage="validateError.name.message"></form-error>
                    </div>
                </div>

                <div class="col-md-4">
                    <div class="form-group">
                        <label for="user_email">email</label>
                        <input type="text" class="form-control" v-model="form.email">
                        <form-error :isError="validateError.email.error" :errorMessage="validateError.email.message"></form-error>
                    </div>
                </div>

                <div class="col-md-4">
                    <div class="form-group">
                        <label for="user_password">password</label>
                        <input type="text" class="form-control" v-model="form.password">
                        <form-error :isError="validateError.password.error" :errorMessage="validateError.password.message"></form-error>
                    </div>
                </div>
                
            </div>            
            <div class="row pt-20">
                <div class="col-md-4">
                    <div class="form-group">
                        <label for="user_status">สถานะ</label>
                        <select class="form-control" v-model="form.status">
                            <option></option>
                            <option :value="'enabled'">enabled</option>
                            <option :value="'disabled'">disabled</option>
                            <option :value="'deleted'">deleted</option>
                        </select>
                        <form-error :isError="validateError.status.error" :errorMessage="validateError.status.message"></form-error>
                    </div>
                </div>                
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group float-right">
                        <a href="javascript:void(0)" onclick="javascript:window.history.back(); return false;" class="btn btn-secondary">ยกเลิก</a>
                        <button type="button" class="btn btn-primary ml-5" @click="saveWithGoBack()">บันทึก</button>
                        <button type="button" v-if="!this.item_id" class="btn btn-primary ml-5" @click="saveWithMore()">บันทึก และ บันทึกเพิ่ม</button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    export default {
        props:{
            item_id:'', //เก็บ id ของ user กรณีที่เป็นการแก้ไข
        },
        components: {                
        },        
        data() {
            return {                
                form:{
                    name:'',
                    email:'',
                    role_id:'',
                    password:'',                    
                    status:'enabled',                                                         
                },
                validateError:{ 
                    // เก็บตัวแปรผลการ submit form ว่ามีฟิลด์ไหน error บ้าง ซึ่งจะ bind กับ ตัวแปรใน <form-error> ให้เลือกเฉพาะฟิลด์ที่ต้อง validate สามารถดูว่าฟิลด์ไหน validate หรือไม่ให้ดูได้ที่ app-backend/app/controller/controller นั้นๆ
                    name:{error:false,message:''},
                    email:{error:false,message:''},
                    role_id:{error:false,message:''},
                    password:{error:false,message:''},
                    status:{error:false,message:''},                    
                },
                permissions:{},
                roles:{}, //เพื่อเก็บและใช้ในตัวเลือก roles  บนฟอร์ม
                base_url:'/user', // base url (เปลี่ยน)                
            }
        },
        mounted() {
        },
        created(){            
            if(this.item_id){
                this.load();
            }
            this.fetchRoles();   
        },
        methods:{
            load(){
                 
                console.log(this.item_id);
                axios.get(this.base_url+'/'+this.item_id)
                .then(response => {
                    console.log(response.data.user[0]);
                    let user = response.data.user[0];
                    this.form.name = user.name;
                    this.form.email = user.email;
                    this.form.role_id = user.role_id;                    
                    this.form.status = user.status;
                    // this.fetchRoles();       

                }).catch(errors => {
                    alert('loading user error', errors)
                    console.log(errors);
                });
            },
            saveWithGoBack(){
                this.save('');
            },            
            saveWithMore(){
                this.save('more');                
            },
            save(whatNext){
                let save_url = '';
                if(this.item_id!=''){
                    save_url = this.base_url+'/'+this.item_id+'/update';
                }else{
                    save_url = this.base_url;
                }

                let me = this;
                //console.log(this.form); 

                //เคลียร์ error ก่อนหน้า
                let fields = Object.keys(this.form);
                fields.forEach(function(item){
                    me.validateError[item].error = false;
                    
                });             
                
                console.log(this.form); //return;
                axios.post(save_url,this.form)
                .then(response => {
                    console.log(response);                    
                    if(whatNext=='more'){
                        // reload form
                        window.location.href = this.base_url+'/form';
                    }else{
                        // go back
                        window.location.href = this.base_url;
                    }
                }).catch(errors => {
                    if(errors.response.data.message){
                        let errorMessage = errors.response.data.message;                                               
                        let fields = Object.keys(this.form);
                        fields.forEach(function(item){
                            // console.log(item);
                            if(typeof errorMessage[item] !='undefined'){
                                me.validateError[item].error = true;
                                me.validateError[item].message = errorMessage[item][0];
                            }
                        });

                    }else{
                        console.log(errors.response.data._infos.result);
                        alert('ไม่สามารถบันทึกได้ '+ errors.response.data);
                    }
                })
                ;
            },
            fetchRoles(url){
                url = url || '/role/list';
                axios.get(url).then(response => {
                    console.log(response.data.items);
                    this.roles = response.data.items;                        
                    this.onRoleChanged(this.form.role_id);
                })
                .catch(errors => {
                    console.log(errors);
                })
                ;
            },
            onRoleChanged(el){
                console.log(el);
                console.log(this.roles);
                let result = this.roles.filter(obj => {
                    return obj.id === el
                })
                console.log(result[0].permission)
                this.permissions = result[0].permission;
            }
        },
    }
</script>